import useSWR from 'swr';
import fetcher from '@/libs/fetcher';
import { useUserState } from '@/context/UserContext';

export default function usePrompts() {
  const { user } = useUserState();
  const { data, error, mutate } = useSWR(
    user?.id ? `/users/${user.id}/prompts` : null,
    (url) => fetcher({ url, needToken: true })
  );

  function create(doc) {
    return fetcher({
      url: `/users/${user.id}/prompts`,
      method: 'POST',
      data: doc,
      needToken: true,
    }).then(() => mutate());
  }

  function update(promptId, doc) {
    return fetcher({
      url: `/users/${user.id}/prompts/${promptId}`,
      method: 'PATCH',
      data: doc,
      needToken: true,
    }).then(() => mutate());
  }

  function remove(promptId) {
    return fetcher({
      url: `/users/${user.id}/prompts/${promptId}`,
      method: 'DELETE',
      needToken: true,
    }).then(() => mutate());
  }

  return {
    prompts: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
    create,
    update,
    remove,
  };
}
